// import 'utils/setupRive';
import {useRivePreload} from "utils";
import {useLayoutEffect} from "react";

export function RivePreload({src, locale = false, module = false}) {

  useLayoutEffect(() => {
    // import('utils/setupRive')
    import('./RiveView')
  }, [])

  // return (
  //   <div style={{position: 'absolute', left: -5000, top: -5000, width: 412, height: 232}}>
  //     <Rive {...props}/>
  //   </div>
  // )

  const {prefetch, blobUrl} = useRivePreload({src, locale, module})

  if (!blobUrl)
    return prefetch
}